export default "__VITE_ASSET__Dfe$aSZx__"